import { TableCellNode, type SerializedTableCellNode } from "@lexical/table";
import type { EditorConfig, LexicalNode, NodeKey } from "lexical";

type SerializedDataTableCellNode = SerializedTableCellNode & {
  type: "data-table-cell";
  border?: string;
};

export class DataTableCellNode extends TableCellNode {
  static getType(): string {
    return "data-table-cell";
  }

  constructor(key?: NodeKey) {
    super(undefined, undefined, undefined, key);
  }

  static clone(node: DataTableCellNode): DataTableCellNode {
    return new this(node.__key);
  }

  exportJSON(): SerializedDataTableCellNode {
    return { ...super.exportJSON(), type: "data-table-cell" };
  }

  static importJSON(): DataTableCellNode {
    return new this();
  }

  createDOM(config: EditorConfig): HTMLTableCellElement {
    const dom = super.createDOM(config);
    dom.classList.add("data-table-cell");
    return dom;
  }
}

export function $createDataTableCellNode(): DataTableCellNode {
  return new DataTableCellNode();
}

export function $isDataTableCellNode(
  node: LexicalNode | null | undefined,
): node is DataTableCellNode {
  return node instanceof DataTableCellNode;
}
